// styles.
import { StyledRulesContainer } from "./styles";

// components.
import { RulesTabs } from "./components/RulesTabs";

export const RulesMain = () => {
  return (
    <StyledRulesContainer>
      <div className="rules-fixed-header">
        <h1 className="rules-title">B-Rules</h1>
      </div>
      <RulesTabs />
    </StyledRulesContainer>
  );
};
